import ArrowRight3Icon from '../../../../../../../assets/svgs/ArrowRight3'
import Bag3Icon from '../../../../../../../assets/svgs/Bag3'
import PositionItem from './PositionItem'
import style from './style.module.css'

const PositionBlock = () => {
  return (
    <div className={style.companyModal_positions}>
      <div className={style.companyModal_position_title}>
        <Bag3Icon />
        <span>Positions</span>
      </div>

      <div className={style.companyModal_position_list}>
        <PositionItem />
        <PositionItem />
        <PositionItem />
      </div>

      <div className={style.companyModal_position_showMore}>
        <span>more</span>
        <ArrowRight3Icon />
      </div>
    </div>
  )
}

export default PositionBlock
